Dafi.View.pjaxContainer = {
    init: function () {
        this.$el = $('[data-pjax-container]');
    }
};